import { render } from "./key-policy.vue?vue&type=template&id=477f250a"
import script from "./key-policy.vue?vue&type=script&lang=js"
export * from "./key-policy.vue?vue&type=script&lang=js"

import exportComponent from "/builds/bluemantis/origo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__